export const ru = {
    timezone: 'Часовой пояс'
};
